import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'prebuiltActivityPack', {
  recommended: 'Selon mes préférences',
  everyone: 'Grand public',
  expositions: 'Expositions',
  familyFriendly: 'Pour la famille',
  nearMe: 'Autour de moi',
  free: 'Gratuit',
  thisWeek: 'Cette semaine',
  series: 'Séries',
})
Locale.getInstance().registerKeySet('en', 'prebuiltActivityPack', {
  recommended: 'According to your interests',
  everyone: 'General public',
  expositions: 'Exhibitions',
  familyFriendly: 'Family Friendly',
  nearMe: 'Near me',
  free: 'Free',
  thisWeek: 'This week',
  series: 'Series',
})
